/* eslint-disable */
import { produce } from "immer";
import {
  TRA_POST_FETCH_START,
  TRA_POST_FETCH_SUCCESS,
  TRA_POST_FETCH_FAILURE,
} from "../actions/types";

const traReducer = (
  state = {
    traFetching: false,
    traData: {},
    traError: null,
  },
  action,
) => {
  switch (action.type) {
    case TRA_POST_FETCH_START:
      return produce(state, (draft) => {
        draft.traFetching = true;
      });
    case TRA_POST_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.traFetching = true;
        draft.traData = action.data;
        draft.traFetching = false;
      });
    case TRA_POST_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.traFetching = false;
        draft.traData = undefined;
        draft.traError = action.error;
      });
    default:
      return state;
  }
};

export default traReducer;
